import { render, staticRenderFns } from "./BodyOrgans.vue?vue&type=template&id=c3c8c400&scoped=true&"
import script from "./BodyOrgans.vue?vue&type=script&lang=ts&"
export * from "./BodyOrgans.vue?vue&type=script&lang=ts&"
import style0 from "./BodyOrgans.vue?vue&type=style&index=0&id=c3c8c400&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3c8c400",
  null
  
)

export default component.exports